"use client";

import React, { ReactNode, useState } from "react";

export interface CollapsibleProps {
  title: string | ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
  className?: string;
}

export function Collapsible({ 
  title, 
  children, 
  defaultOpen = false,
  className = ""
}: CollapsibleProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`border border-gray-200 rounded-lg overflow-hidden ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-4 bg-white hover:bg-gray-50 transition-colors duration-200 flex items-center justify-between text-left"
        aria-expanded={isOpen}
      >
        {typeof title === 'string' ? (
          <span className="text-sm font-medium text-gray-900">{title}</span>
        ) : (
          <div className="flex-1">{title}</div>
        )}
        <svg
          className={`w-5 h-5 text-gray-500 transform transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      {isOpen && (
        <div className="px-6 pb-4 bg-white">
          <div className="text-sm text-gray-700">{children}</div>
        </div>
      )}
    </div>
  );
}